import React from 'react';
import styled from 'styled-components/macro';
import { keyframes, css } from "styled-components/macro";

const StyledLoader = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  background-color: #046644;
`;

const StyledLoadingBar = styled.div`
  content: "";
  display: inline;
  position: absolute;
  width: 0;
  height: 100%;
  left: 50%;
  text-align: center;
  
  &:nth-child(1) {
    // background-color: #da4733;
    background-color: #05ac72;
    animation: ${() => css`${loading} 3s linear infinite`};
  }
  
  &:nth-child(2) {
    // background-color: #3b78e7;
    background-color: #09d48b; 
    animation: ${() => css`${loading} 3s linear 1s infinite`}
  }
  
  &:nth-child(3) {
    // background-color: #fdba2c;
    background-color: #3bfeb7;
    animation: ${() => css`${loading} 3s linear 2s infinite`}
  }
`;

const loading = keyframes`
  from {left: 50%; width: 0;z-index:100;}
  33.3333% {left: 0; width: 100%;z-index: 10;}
  to {left: 0; width: 100%;}
`;

export const LoadingBar = props => {
  return (
    <StyledLoader className="loading-bar" {...props}>
      <StyledLoadingBar/>
      <StyledLoadingBar/>
      <StyledLoadingBar/>
    </StyledLoader>
  )
};

export default LoadingBar;
